export const USCIS_CASE_TYPE_MAP = {
  'I-130': 'I-130',
  'I-140': 'I-140',
  'I-360': 'I-360',
}
